export const CONTACT_INFO = {
  email: "caramelcottage@gmail.com",
  phone: "+91 9496250505",
  whatsapp: "919496250505",
};